import type { App } from "vue";

import {
  ElAside,
  ElButton,
  ElCheckbox,
  ElCol,
  ElContainer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElForm,
  ElFormItem,
  ElHeader,
  ElInput,
  ElLink,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElSubmenu,
  ElTabPane,
  ElTabs,
  ElRow,
  ElSelect,
  ElRadio,
  ElDatePicker,
  ElOption,
  ElBreadcrumbItem,
  ElBreadcrumb,
  ElTable,
  ElTableColumn,
  ElPagination,
  ElImage,
  ElDialog,
  ElTree,
  ElAvatar,
  ElUpload,
  ElCard,
  ElTooltip,
  ElCollapse,
  ElCollapseItem,
  ElDescriptions,
  ElDescriptionsItem,
  ElCheckboxGroup,
  ElTag,
  ElRadioGroup,
  ElSwitch,
  ElCascader,
  ElInputNumber,
  ElDrawer,
  ElSlider,
  ElPopconfirm,
  ElSteps,
  ElStep,
  ElBadge,
  ElPopover,
  ElDivider,
  ElTimeline,
  ElTimelineItem,
  ElLoading
} from "element-plus";

import "element-plus/lib/theme-chalk/base.css";

const components = [
  ElButton,
  ElTabs,
  ElTabPane,
  ElForm,
  ElFormItem,
  ElInput,
  ElCheckbox,
  ElCheckboxGroup,
  ElLink,
  ElContainer,
  ElAside,
  ElHeader,
  ElMain,
  ElMenu,
  ElSubmenu,
  ElCol,
  ElMenuItem,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElRow,
  ElSelect,
  ElOption,
  ElDatePicker,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElTable,
  ElTableColumn,
  ElPagination,
  ElImage,
  ElDialog,
  ElTree,
  ElAvatar,
  ElUpload,
  ElCard,
  ElTooltip,
  ElCollapse,
  ElCollapseItem,
  ElDescriptions,
  ElDescriptionsItem,
  ElTag,
  ElRadio,
  ElRadioGroup,
  ElSwitch,
  ElCascader,
  ElInputNumber,
  ElDrawer,
  ElSlider,
  ElPopconfirm,
  ElSteps,
  ElStep,
  ElBadge,
  ElPopover,
  ElDivider,
  ElTimeline,
  ElTimelineItem,
  ElLoading
];

export default function (app: App): void {
  for (const cpn of components) {
    app.component(cpn.name, cpn);
  }
}
